// AssetsTableRow.jsx

import AssetsTableCell from "./assets-table-cell.jsx";
import projectUtils from "../../../../utils/project-utils.js";

export default function AssetsTableRow({ asset }) {
    return (
        <tr>
            <AssetsTableCell>{asset.description}</AssetsTableCell>
            <AssetsTableCell>{asset.asset_number}</AssetsTableCell>
            <AssetsTableCell>{asset.serial_number}</AssetsTableCell>
            <AssetsTableCell>{asset.place}</AssetsTableCell>
            <AssetsTableCell>{asset.brand}</AssetsTableCell>
            <AssetsTableCell>{asset.model}</AssetsTableCell>
            <AssetsTableCell>{asset.status}</AssetsTableCell>
            <AssetsTableCell>{asset.type}</AssetsTableCell>
            <AssetsTableCell>{asset.supplier}</AssetsTableCell>
            <AssetsTableCell>
                {projectUtils.formatDate(asset.warranty, "DD/MM/YYYY")}
            </AssetsTableCell>
        </tr>
    );
}